import { setExternalSubscription, setExternalSubscriptionStatus } from '@va/aaas/shared/actions';
import { AaasPaymentsApi } from '@va/aaas/shared/api-client';
import { selectIntpWebsite } from '@va/aaas/shared/selectors';
import { CustomerInfo, ExternalSubscription, IntpWebsite } from '@va/aaas/shared/types';
import { apiStatus } from '@va/constants';
import { getInstanceId } from '@va/dashboard/selectors/app';
import { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

export function* fetchExternalSubscriptionSaga(): SagaIterator {
  const websiteId: string = yield select(getInstanceId);

  const intpWebsite: IntpWebsite = yield select(selectIntpWebsite);

  yield put(setExternalSubscriptionStatus(apiStatus.IN_PROGRESS));

  try {
    const customer: CustomerInfo = yield call(AaasPaymentsApi.getCustomer, intpWebsite.subscriptionType, websiteId);
    if (!customer) {
      throw new Error('customer not created');
    }
    const data: ExternalSubscription = yield call(AaasPaymentsApi.getExternalSubscription, customer.id);
    yield put(setExternalSubscription(data));
    yield put(setExternalSubscriptionStatus(apiStatus.SUCCEEDED));
  } catch (error) {
    yield put(setExternalSubscriptionStatus(apiStatus.FAILED));
    console.error(error);
  }
}
